import { render, staticRenderFns } from "./CancelTransfer.vue?vue&type=template&id=8042116c&scoped=true"
import script from "./CancelTransfer.vue?vue&type=script&lang=js"
export * from "./CancelTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8042116c",
  null
  
)

export default component.exports